module.exports = __webpack_public_path__ + "img/common-file-info.fda3054a.svg";